var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mainWindow"}},[_c('mainCard',{ref:"main",class:_vm.main,staticStyle:{"position":"absolute"},on:{"scc":_vm.changeScene}}),_c('gameCard',{ref:"game",class:_vm.game,staticStyle:{"position":"absolute"},on:{"backTitle":_vm.changeScene_reverse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }